module.exports = __webpack_public_path__ + "img/elpolab-logo.d76b1026.jpg";